/**
 * Demo page: /ui-elements/buttons (ghost button).
 * Spec 76 Phase B — ContextPanelBreadcrumb.
 *
 * Tiny inline breadcrumb shown at the top of the chat rail when the
 * active thread is a child (entity-assistant) thread. Clicking calls
 * the provided `onClick` to return to the parent thread.
 *
 * Phase C wires the rendering condition (when to show / hide it).
 */
import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../ui/Button.js';

interface ContextPanelBreadcrumbProps {
  /** Human-readable parent context label (e.g. the parent conversation title). */
  parentLabel: string;
  /** Called when the user clicks the breadcrumb to return to the parent thread. */
  onClick: () => void;
}

export const ContextPanelBreadcrumb: React.FC<ContextPanelBreadcrumbProps> = ({ parentLabel, onClick }) => (
  <Button variant="ghost" size="sm" onClick={onClick} aria-label={`Return to ${parentLabel}`}>
    <ArrowLeft size={12} aria-hidden="true" />
    <span>Project: {parentLabel}</span>
  </Button>
);
